import { render, staticRenderFns } from "./PageNoCompany.vue?vue&type=template&id=58a7b038&scoped=true&"
import script from "./PageNoCompany.vue?vue&type=script&lang=js&"
export * from "./PageNoCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7b038",
  null
  
)

export default component.exports